import * as z from "zod";

export const inventoryAdjustmentReasonDirectionSchema = z.enum([
  "positive",
  "negative",
]);

export type InventoryAdjustmentReasonDirection = z.infer<
  typeof inventoryAdjustmentReasonDirectionSchema
>;
